import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

// Base path
export const PATH_TAX_WITHHOLDINGS = "/member/tax-withholdings";

// Legacy base path — kept only to redirect old links to the new path
export const PATH_TAX_WITHHOLDINGS_LEGACY = "/member/taxes";

// Parameter constants
export const PARAMETER_TAX_PAYMENT_ID = "taxPaymentId";

// Composed paths
export const PATH_TAX_WITHHOLDINGS_EDIT_TAX_RATE = `${PATH_TAX_WITHHOLDINGS}/edit/tax-rate`;
// [LEGACY] The tax profile and the rate were merged into one screen; this path
// only exists to redirect anything still pointing at it to the rate path.
export const PATH_TAX_WITHHOLDINGS_EDIT_TAX_PROFILE = `${PATH_TAX_WITHHOLDINGS}/edit/tax-profile`;
export const PATH_TAX_WITHHOLDINGS_SURVEY = `${PATH_TAX_WITHHOLDINGS}/survey`;
export const PATH_TAX_WITHHOLDINGS_SCHEDULE_PAYMENT = `${PATH_TAX_WITHHOLDINGS}/schedule-payment`;
export const PATH_TAX_WITHHOLDINGS_SCHEDULE_PAYMENT_CONFIRMATION = `${PATH_TAX_WITHHOLDINGS_SCHEDULE_PAYMENT}/confirmation/:${PARAMETER_TAX_PAYMENT_ID}`;

// Path helpers
export const routeHelpersTaxWithholdingsSchedulePaymentConfirmation =
  createRouteHelpers<{ taxPaymentId: string }, { state: { amount: number } }>(
    PATH_TAX_WITHHOLDINGS_SCHEDULE_PAYMENT_CONFIRMATION
  );
